import qccapis  from "../../api/qcc";

export default {
    name: "CreditQuery",
    data() {
        return {
          keyword:"",
          idCard:"",
          dataList:[],  
          dataShow:false,
          data2Show:false,
          count:0,
          pageIndex:1,
          llListDialogShow:false,
          llTableData:[],
        };
    },
    beforeCreate: function () {
      let meta = this.$route.meta
      if(meta&&meta.permBtns.length>0){
        this.permBtns = meta.permBtns
      }
    },
    created() {

    },
    methods: {
        query(index){
          var idCard=this.idCard;
          if(this.keyword==""&&idCard==""){
            this.$message.error("请输入关键字或者身份证");return;
             }
             if(this.keyword==""){
              var regName =/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; 
              if(!regName.test(idCard)){
                this.$message.error("身份证号不合规范");return;
               }
               var param2={
                idCard:idCard,
                keyword:""
                }
              let routerJump = this.$router.resolve({ path: '/CreditReport', query: param2 });
              window.open(routerJump.href, '_blank');

              return;

            }
          
          this.data2Show=false;
          if(index==1){
            this.count=0;
            this.dataShow=false;
            this.pageIndex=1;
            this.dataList=[]
            if(this.keyword==""){
                this.$message.error("请输入关键字");return;
            }
          }else{
            this.pageIndex++;
          }
            let param={
              keyword:this.keyword,
              pageIndex:this.pageIndex
            };
            var that=this;
            var dataList=this.dataList;
            qccapis.getCompanyList(param).then(res => {
                            this.dataShow=true;
                              if(res!=null){
                                if(Number(res.Status)==200){
                                  var list=res.Result
                                  for(var i=0;i<list.length;i++){
                                      list[i].url="https://image.qcc.com/auto/"+list[i].KeyNo+".jpg?x-oss-process=style/logo_200"
                                      dataList.push(list[i]);
                                  }
                                  that.count=res.Paging.TotalRecords;
                                  // 翻页功能
                                  // that.count=list.length;
                                  if(that.count==0){
                                    that.getLL();
                                  }
                                }else{
                                  that.dataList = [];
                                  that.$message.error(res.Message);
                                  // that.getLL();
                                }
                              }else{
                                  that.dataList = [];
                                  that.$message.error("查询公司列表失败")
                              }

                      });
        },
        getLL(){
          this.dataShow=false;
          var idCard=this.idCard;
          var regName =/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; 
          if(!regName.test(idCard)){
            this.$message.error("身份证号不合规范");return;
           }
          // this.llTableData=[{"Id":"3d91a421e26ac3f3e96d691d25ae1752","Name":"贲松柏","OriginalName":null,"CerNo":"4205231967****0051","Province":"HUB","TagDesc":["限制高消费"],"Type":"1","Count":"1","Description":"贲松柏，男，1967年出生，湖北人。","Oper":null,"RegistCapi":null,"StartDate":null},{"Id":"3d91a421e26ac3f3e96d691d25ae1752","Name":"贲松柏","OriginalName":null,"CerNo":"4205231967****0051","Province":"HUB","TagDesc":["限制高消费"],"Type":"1","Count":"1","Description":"贲松柏，男，1967年出生，湖北人。","Oper":null,"RegistCapi":null,"StartDate":null}]
           var param={
            idCard:idCard
          }
          var that=this;
          qccapis.getLL(param).then(res => {
                if(res!=null){
                  if(Number(res.Status)==200){
                  that.data2Show=true;
                  var llTableData = res.Result.Data;
                  var list=[];
                  if(llTableData){
                  for(var i=0;i<llTableData.length;i++){
                    var cerNo=llTableData[i].CerNo.replace('<em>', '');
                    llTableData[i].CerNo=cerNo.replace('</em>', '');
                    if(llTableData[i].Name==this.keyword||llTableData[i].Name==this.OperName)list.push(llTableData[i])
                  }
                  that.llTableData=list;}
                }else{
                  that.llTableData = [];
                  that.$message.error(res.Message)
                }
              }else{
                that.llTableData = [];
                that.$message.error("查询老赖信息失败")
            }
           });
         },
         getLLDetail(){
          if(this.llTableData.length>0){
              let id = this.llTableData[0].Id
              let param = {
                  id:id
              }
              var that=this;
              qccapis.getLLDetail(param).then(res => {
                if(res!=null){
                  if(Number(res.Status)==200){
                  that.llListDialogShow=true;
                  that.llListResult = res.Result.Data;
                }else{
                  that.llListResult = [];
                  that.$message.error(res.Message)
                }
              }else{
                that.llListResult = [];
                that.$message.error("查询老赖失信列表信息失败")
            }
           });
          }

      },
        showDetail(data){
          var idCard=this.idCard;
          if(idCard!=""){
          var regName =/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; 
          if(!regName.test(idCard)){
            this.$message.error("身份证号不合规范");return;
           }
          }
           var param={
            idCard:idCard,
            code:data.CreditCode,
          }
          let routerJump = this.$router.resolve({ path: '/CreditReport', query: param });
          window.open(routerJump.href, '_blank');
      },
      handleOne(){
        var idCard=this.idCard;
        if(idCard!=""){
        var regName =/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; 
        if(!regName.test(idCard)){
          this.$message.error("身份证号不合规范");return;
         }
        }else{
          this.$message.error("请输入身份证号");return;
        }
         var param={
          idCard:idCard,
          code:"",
          keyword:this.keyword,
          OperName:""
        }
        let routerJump = this.$router.resolve({ path: '/CreditReport', query: param });
        window.open(routerJump.href, '_blank');
      }
    },
  
  };
